<template>
    <div class="card-formulario-reclamacao-tecnica">
        <g-card :expansivel="false" :temCabecalho="false">
            <div class="cabecalho-formulario">
                <div class="titulo-formulario titulo-formulario-reclamacao"> Formulário de Reclamação Técnica / Comercial </div>
            </div>

            <g-form>
                <div class="titulo-popup-finalizado"> PREENCHA O FORMULÁRIO </div>
                <div class="conteudo-formulario-reclamacao espacamento-formulario">
                    <div class="grupo-dados-cliente-unidade">
                        <div class="dados-unidade">
                            <div class="titulo-conteudo-filtros"> Unidade </div>              
                            <PInputText 
                            disabled                             
                            v-model="unidade" 
                            >
                            </PInputText>
                        </div>

                        <div class="dados-cnpj">
                            <div class="titulo-conteudo-filtros"> CNPJ </div>              
                            <PInputText 
                            disabled
                            v-model="this.cnpj" 
                            >
                            </PInputText>
                        </div>

                        <div class="dados-codigo-cliente">
                            <div class="titulo-conteudo-filtros"> Código do Cliente </div>              
                            <PInputText 
                            disabled                             
                            v-model="codigo"
                            >
                            </PInputText>
                        </div>

                        <div class="dados-razao-social">
                            <div class="titulo-conteudo-filtros"> Razão Social </div>              
                            <PInputText 
                            disabled                        
                            v-model="razaoSocial" 
                            >
                            </PInputText>
                        </div>
                    </div>

                    <div class="linha-separacao"></div>
                    
                    <div class="dados-produto">
                        <div class="titulo-conteudo-filtros"> Selecione o Produto <strong class="asterisco-obrigatorio">*</strong> </div>              
                        <PDropDown
                            v-model="produto"
                            class="nome-produto-input"
                            optionLabel="labelProduto"
                            optionValue="produtoId"
                            placeholder="Escolha um produto"
                            :filter="true"
                            :options="ProdutoArray"
                            @change="PesquisaPedidoByProduto()"
                        />
                    </div>

                    <div class="grupo-dados-pedido-parcela">

                        <div class="dados-pedido">
                            <div class="titulo-conteudo-filtros"> Pedido <strong class="asterisco-obrigatorio">*</strong></div>              
                            <PDropDown 
                            :disabled = "this.produto == null ? true : false"
                            :filter="true" 
                            placeholder="Escolha um número de pedido"
                            :options="PedidoArray"                    
                            optionLabel="descricaoPedido" 
                            optionValue="pedidoId" 
                            v-model="pedido" 
                            >
                            </PDropDown>
                        </div>

                        <div class="dados-parcela">
                            <div class="titulo-conteudo-filtros"> Parcela <strong class="asterisco-obrigatorio">*</strong></div>              
                            <PInputText 
                            placeholder="Adicione o número" 
                            type="int"
                            maxlength="112214"
                            v-mask="'####'" 
                            v-model="parcela"                     
                            >
                            </PInputText>
                        </div>

                        <div class="dados-ordem-servico">
                            <div class="titulo-conteudo-filtros"> Ordem de Serviço </div>              
                            <PInputText 
                            placeholder="Insira a Ordem de Serviço" 
                            type="int" 
                            maxlength="6" 
                            v-mask="'######'" 
                            v-model="ordemservico"
                            >
                            </PInputText>
                        </div>

                        <div class="dados-nota-fiscal">
                            <div class="titulo-conteudo-filtros"> Nota Fiscal <strong class="asterisco-obrigatorio">*</strong></div>              
                            <PInputText 
                            placeholder="Insira o número da nota"
                            type="int" 
                            maxlength="6" 
                            v-mask="'######'" 
                            v-model="notafiscal"                         
                            >
                            </PInputText>
                        </div>

                        <div class="dados-quantidade">
                            <div class="titulo-conteudo-filtros"> Quantidade com problema <strong class="asterisco-obrigatorio">*</strong></div>              
                            <PInputText 
                            placeholder="Adicione a quantidade"  
                            type="int"
                            v-mask="'######'" 
                            v-model="quantidade"
                            >
                            </PInputText>
                            <div class="input-checkbox">
                                <PCheckBox                             
                                :binary="true" 
                                v-model="acompanhaamostra"
                                ></PCheckBox>
                                <label class="label-checkbox" for="ext"> Acompanha amostra? </label>
                            </div>   
                        </div>

                        <div class="dados-descricao">
                            <div class="titulo-conteudo-filtros"> Descrição <strong class="asterisco-obrigatorio">*</strong></div>              
                            <PTextArea 
                            class="descricao"
                            placeholder="Insira uma breve descrição"
                            type="int" 
                            maxlength="200" 
                            v-model="descricao"
                            >
                            </PTextArea>
                        </div>
                    </div>
                </div>
            </g-form>

            <div class="buttons-next-back">
                <div class="button-next">
                    <g-button
                    tipo="amarelo" 
                    negritoTexto 
                    altura="35px"
                    largura="100%"
                    @click="valida()" 
                    >
                        GERAR
                    </g-button>
                </div>
                <div class="button-back">
                    <g-button 
                    tipo="cinza" 
                    altura="35px"
                    largura="100%"
                    negritoTexto 
                    @click="voltar()"
                    >
                        VOLTAR
                    </g-button>
                </div>
            </div>

          <PDialog :showHeader="false" :closable="false" v-model:visible="popup" :modal="true">
          <div class="titulo-popup-finalizado"> Formulário {{this.NumeroFormulario}} gerado com sucesso! </div>
          <div class="botoes-popup">
            <div>
              <g-button
              tipo="cinza"
              negritoTexto 
              largura="200px" 
              altura="35px" 
              @click="consultarFormulario"
              >
              CONSULTAR
              </g-button>
            </div>
          </div>
        </PDialog>
        </g-card>
    </div>
</template>
  
<script>
import ReclamacaoTecnicaComercialFormulario from './ReclamacaoTecnicaComercialFormulario.js'
export default ReclamacaoTecnicaComercialFormulario
</script>
  
<style scoped>
.descricao {
    height: 43px;
}
.titulo-popup-finalizado {
    padding: 40px 0 30px;
}

@media (min-width:310px) {
.espacamento-formulario {
    margin: 0 20px;
}
}

@media (min-width:368px) {

}

@media (min-width:400px) {
.espacamento-formulario {
    margin: 0 50px;
} 
}

@media (min-width:600px) {

}

@media (min-width:700px) {
.espacamento-formulario {
    margin: 0 80px;
} 

.grupo-dados-cliente-unidade {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, auto);
    grid-column-gap: 20px;
}

.dados-unidade { grid-area: 1 / 1 / 2 / 2; }
.dados-cnpj { grid-area: 1 / 2 / 2 / 3; }
.dados-codigo-cliente { grid-area: 2 / 1 / 3 / 2; }
.dados-razao-social { grid-area: 2 / 2 / 3 / 3; }

.grupo-dados-pedido-parcela {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
    grid-column-gap: 20px;
}

.dados-pedido { grid-area: 1 / 1 / 2 / 2; }
.dados-parcela { grid-area: 1 / 2 / 2 / 3; }
.dados-ordem-servico { grid-area: 2 / 1 / 3 / 2; }
.dados-nota-fiscal { grid-area: 2 / 2 / 3 / 3; }
.dados-quantidade { grid-area: 3 / 1 / 4 / 2; }
.dados-descricao { grid-area: 4 / 1 / 5 / 3; }
}

@media (min-width:801px) {
.espacamento-formulario {
    margin: 0 150px;
}
}

@media (min-width:1025px) {

}

@media (min-width:1281px) {
    
}

@media (min-width: 1300px) {
.grupo-dados-cliente-unidade {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
}

.dados-unidade { grid-area: 1 / 1 / 2 / 2; }
.dados-cnpj { grid-area: 1 / 2 / 2 / 3; }
.dados-codigo-cliente { grid-area: 1 / 3 / 2 / 4; }
.dados-razao-social { grid-area: 1 / 4 / 2 / 5; }

.grupo-dados-pedido-parcela {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr);
}

.dados-pedido { grid-area: 1 / 1 / 2 / 2; }
.dados-parcela { grid-area: 1 / 2 / 2 / 3; }
.dados-ordem-servico { grid-area: 1 / 3 / 2 / 4; }
.dados-nota-fiscal { grid-area: 1 / 4 / 2 / 5; }
.dados-quantidade { grid-area: 2 / 1 / 3 / 2; }
.dados-descricao { grid-area: 2 / 2 / 3 / 5; }
}

@media (min-width:1500px) {
.espacamento-formulario {
    margin: 0 200px;
}
}
</style>